import { render, staticRenderFns } from "./footer4.vue?vue&type=template&id=60949309&scoped=true"
import script from "./footer4.vue?vue&type=script&lang=js"
export * from "./footer4.vue?vue&type=script&lang=js"
import style0 from "./footer4.vue?vue&type=style&index=0&id=60949309&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60949309",
  null
  
)

export default component.exports